module.exports = __webpack_public_path__ + "img/login_background.88bb70cf.png";